import 'assets/css/style.css';

import forbiddenPageImage from 'assets/images/403-pic.svg';
import forbiddenPageText from 'assets/images/403-text.svg';

import { getRedirectPath } from './functions';

function ForbiddenPage() {
  const redirectPath = getRedirectPath();

  return (
    <article className="text-center system-page">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6">
          <img src={forbiddenPageText} alt="" />
          <p className="margin-bottom">
            {translate('You may not have the appropriate permissions to access this page.')}
            <br />
            {translate('If you feel this is a mistake, please contact your administrator.')}
          </p>
          <a href={redirectPath}>
            <i className="lnr lnr-arrow-left-circle margin-right" />
            {translate('Back to Home page')}
          </a>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6">
          <img src={forbiddenPageImage} alt="" />
        </div>
      </div>
    </article>
  );
}

// eslint-disable-next-line import/no-default-export
export default ForbiddenPage;
